/** DCF V2 status workflow (matches dcf_statuses catalog). */
export const DCF_STATUS = {
  IN_DRAFT: 'in_draft',
  SUBMITTED: 'submitted',
  IN_REVIEW: 'in_review',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  COMPLETED: 'completed',
}

/** Content edit allowed only before submission. */
export const EDITABLE_STATUSES = new Set([DCF_STATUS.IN_DRAFT])

/** Signatures are captured only while the review is in progress. */
export const SIGNABLE_STATUSES = new Set([DCF_STATUS.IN_REVIEW])

export const REJECTABLE_STATUSES = new Set([DCF_STATUS.SUBMITTED, DCF_STATUS.IN_REVIEW])

export const APPLYABLE_STATUSES = new Set([DCF_STATUS.APPROVED])

export const TERMINAL_STATUSES = new Set([DCF_STATUS.COMPLETED, DCF_STATUS.REJECTED])

export const canEditDcfContent = status => EDITABLE_STATUSES.has(status)
export const canEditSignatures = status => SIGNABLE_STATUSES.has(status)
export const canRejectDcf = status => REJECTABLE_STATUSES.has(status)
/**
 * Apply when approved. Most actions need a linked instance_id;
 * create_new_record provisions the instance on apply.
 */
export const canApplyDcf = (status, detail = null) => {
  if (!APPLYABLE_STATUSES.has(status)) return false
  if (detail == null) return true
  if (detail.action === 'create_new_record') return true
  return Boolean(detail.instance_id)
}
export const isTerminalDcf = status => TERMINAL_STATUSES.has(status)
export const canDownloadDcfPdf = status =>
  Boolean(status) && status !== DCF_STATUS.IN_DRAFT
export const canDownloadDcfCsv = status =>
  Boolean(status) && status !== DCF_STATUS.IN_DRAFT
/** Associate / replace instance from the list (any non-terminal DCF). */
export const canAssociateDcfInstance = status =>
  Boolean(status) && !TERMINAL_STATUSES.has(status)
